import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { HomeIcon, LayoutDashboardIcon, ShoppingBagIcon, PackageIcon, MessageSquareIcon, UserIcon, MenuIcon, XIcon, BuildingIcon, SparklesIcon } from 'lucide-react';
// Mobile detector
const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);
const Navigation = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  // For mobile devices, we'll use a bottom navigation bar
  if (isMobile) {
    return <>
        {/* Top header for mobile */}
        <header className="bg-white shadow-md fixed top-0 left-0 right-0 z-40" data-id="element-308">
          <div className="container mx-auto px-4 py-3" data-id="element-309">
            <div className="flex items-center justify-between" data-id="element-310">
              <Link to="/" className="flex items-center" data-id="element-311">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qafga1SjQGgNLQJiY1ZPaE/Veriprop_logo.png" alt="VeriProp Logo" className="h-8 w-auto" data-id="element-312" />
              </Link>
              <button className="p-2" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-313">
                {isMenuOpen ? <XIcon size={24} data-id="element-314" /> : <MenuIcon size={24} data-id="element-315" />}
              </button>
            </div>
          </div>
        </header>
        {/* Mobile menu overlay */}
        {isMenuOpen && <div className="fixed inset-0 bg-[#1A1F47] bg-opacity-75 z-50 pt-16" data-id="element-316">
            <div className="bg-white h-full overflow-y-auto" data-id="element-317">
              <div className="p-4" data-id="element-318">
                <div className="flex justify-between items-center mb-6" data-id="element-319">
                  <div className="flex items-center" data-id="element-320">
                    <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qafga1SjQGgNLQJiY1ZPaE/Veriprop_logo.png" alt="VeriProp Logo" className="h-8 w-auto" data-id="element-321" />
                  </div>
                  <button className="p-2" onClick={() => setIsMenuOpen(false)} data-id="element-322">
                    <XIcon size={24} data-id="element-323" />
                  </button>
                </div>
                <div className="flex flex-col space-y-4" data-id="element-324">
                  <MobileNavLink to="/" icon={<HomeIcon size={20} data-id="element-326" />} label="Home" onClick={() => setIsMenuOpen(false)} data-id="element-325" />
                  <MobileNavLink to="/veribot" icon={<SparklesIcon size={20} data-id="element-328" />} label="VeriBot AI" onClick={() => setIsMenuOpen(false)} highlight data-id="element-327" />
                  <MobileNavLink to="/properties" icon={<BuildingIcon size={20} data-id="element-330" />} label="Properties" onClick={() => setIsMenuOpen(false)} data-id="element-329" />
                  <MobileNavLink to="/dashboard" icon={<LayoutDashboardIcon size={20} data-id="element-332" />} label="Dashboard" onClick={() => setIsMenuOpen(false)} data-id="element-331" />
                  <MobileNavLink to="/services" icon={<ShoppingBagIcon size={20} data-id="element-334" />} label="Services" onClick={() => setIsMenuOpen(false)} data-id="element-333" />
                  <MobileNavLink to="/track" icon={<PackageIcon size={20} data-id="element-336" />} label="Track Delivery" onClick={() => setIsMenuOpen(false)} data-id="element-335" />
                  <MobileNavLink to="/chat" icon={<MessageSquareIcon size={20} data-id="element-338" />} label="Messages" onClick={() => setIsMenuOpen(false)} data-id="element-337" />
                  <MobileNavLink to="/auth" icon={<UserIcon size={20} data-id="element-340" />} label="Sign In" onClick={() => setIsMenuOpen(false)} data-id="element-339" />
                </div>
              </div>
            </div>
          </div>}
        {/* Bottom navigation for mobile */}
        <div className="mobile-nav-fixed flex justify-around py-2 z-40 safe-area-bottom" data-id="element-341">
          <BottomNavLink to="/" icon={<HomeIcon size={24} data-id="element-343" />} label="Home" data-id="element-342" />
          <BottomNavLink to="/properties" icon={<BuildingIcon size={24} data-id="element-345" />} label="Properties" data-id="element-344" />
          <BottomNavLink to="/veribot" icon={<SparklesIcon size={24} data-id="element-347" />} label="VeriBot" highlight data-id="element-346" />
          <BottomNavLink to="/dashboard" icon={<LayoutDashboardIcon size={24} data-id="element-349" />} label="Dashboard" data-id="element-348" />
          <BottomNavLink to="/auth" icon={<UserIcon size={24} data-id="element-351" />} label="Account" data-id="element-350" />
        </div>
      </>;
  }
  // Desktop navigation
  return <header className="bg-white shadow-md" data-id="element-352">
      <div className="container mx-auto px-4 py-3" data-id="element-353">
        <div className="flex items-center justify-between" data-id="element-354">
          <Link to="/" className="flex items-center" data-id="element-355">
            <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qafga1SjQGgNLQJiY1ZPaE/Veriprop_logo.png" alt="VeriProp Logo" className="h-8 w-auto" data-id="element-356" />
          </Link>
          <nav className="hidden md:flex items-center space-x-8" data-id="element-357">
            <NavLink to="/" icon={<div className="flex items-center" data-id="element-359">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qafga1SjQGgNLQJiY1ZPaE/Veriprop_logo.png" alt="VeriProp Logo" className="h-5 w-auto mr-2" data-id="element-360" />
                  <HomeIcon size={18} data-id="element-361" />
                </div>} label="Home" data-id="element-358" />
            <NavLink to="/veribot" icon={<SparklesIcon size={18} data-id="element-363" />} label="VeriBot AI" highlight data-id="element-362" />
            <NavLink to="/properties" icon={<BuildingIcon size={18} data-id="element-365" />} label="Properties" data-id="element-364" />
            <NavLink to="/dashboard" icon={<LayoutDashboardIcon size={18} data-id="element-367" />} label="Dashboard" data-id="element-366" />
            <NavLink to="/services" icon={<ShoppingBagIcon size={18} data-id="element-369" />} label="Services" data-id="element-368" />
            <NavLink to="/track" icon={<PackageIcon size={18} data-id="element-371" />} label="Track Delivery" data-id="element-370" />
            <NavLink to="/chat" icon={<MessageSquareIcon size={18} data-id="element-373" />} label="Messages" data-id="element-372" />
          </nav>
          <div className="hidden md:flex items-center space-x-4" data-id="element-374">
            <Link to="/auth" className="flex items-center space-x-1 px-4 py-2 rounded-lg bg-[#FF4E00] text-white hover:bg-[#e64600] transition" data-id="element-375">
              <UserIcon size={18} data-id="element-376" />
              <span data-id="element-377">Sign In</span>
            </Link>
          </div>
          <button className="md:hidden p-2" onClick={() => setIsMenuOpen(!isMenuOpen)} data-id="element-378">
            {isMenuOpen ? <XIcon size={24} data-id="element-379" /> : <MenuIcon size={24} data-id="element-380" />}
          </button>
        </div>
        {/* Mobile menu */}
        {isMenuOpen && <div className="md:hidden mt-4 pb-4" data-id="element-381">
            <div className="flex flex-col space-y-3" data-id="element-382">
              <MobileNavLink to="/" icon={<HomeIcon size={18} data-id="element-384" />} label="Home" onClick={() => setIsMenuOpen(false)} data-id="element-383" />
              <MobileNavLink to="/veribot" icon={<SparklesIcon size={18} data-id="element-386" />} label="VeriBot AI" onClick={() => setIsMenuOpen(false)} highlight data-id="element-385" />
              <MobileNavLink to="/properties" icon={<BuildingIcon size={18} data-id="element-388" />} label="Properties" onClick={() => setIsMenuOpen(false)} data-id="element-387" />
              <MobileNavLink to="/dashboard" icon={<LayoutDashboardIcon size={18} data-id="element-390" />} label="Dashboard" onClick={() => setIsMenuOpen(false)} data-id="element-389" />
              <MobileNavLink to="/services" icon={<ShoppingBagIcon size={18} data-id="element-392" />} label="Services" onClick={() => setIsMenuOpen(false)} data-id="element-391" />
              <MobileNavLink to="/track" icon={<PackageIcon size={18} data-id="element-394" />} label="Track Delivery" onClick={() => setIsMenuOpen(false)} data-id="element-393" />
              <MobileNavLink to="/chat" icon={<MessageSquareIcon size={18} data-id="element-396" />} label="Messages" onClick={() => setIsMenuOpen(false)} data-id="element-395" />
              <MobileNavLink to="/auth" icon={<UserIcon size={18} data-id="element-398" />} label="Sign In" onClick={() => setIsMenuOpen(false)} data-id="element-397" />
            </div>
          </div>}
      </div>
    </header>;
};
interface NavLinkProps {
  to: string;
  icon: React.ReactNode;
  label: string;
  highlight?: boolean;
}
const NavLink = ({
  to,
  icon,
  label,
  highlight
}: NavLinkProps) => <Link to={to} className={`flex items-center space-x-1 transition ${highlight ? 'text-[#FF4E00] font-semibold' : 'text-gray-700 hover:text-[#FF4E00]'}`} data-id="element-399">
    {icon}
    <span data-id="element-400">{label}</span>
  </Link>;
interface MobileNavLinkProps extends NavLinkProps {
  onClick: () => void;
}
const MobileNavLink = ({
  to,
  icon,
  label,
  onClick,
  highlight
}: MobileNavLinkProps) => <Link to={to} className={`flex items-center space-x-2 p-4 rounded-lg ${highlight ? 'bg-gradient-to-r from-[#FF4E00] to-[#FF6B2C] text-white' : 'hover:bg-gray-100'}`} onClick={onClick} data-id="element-401">
    {icon}
    <span className="text-lg" data-id="element-402">{label}</span>
  </Link>;
const BottomNavLink = ({
  to,
  icon,
  label,
  highlight
}: NavLinkProps) => <Link to={to} className={`flex flex-col items-center justify-center px-2 py-1 ${highlight ? 'text-[#FF4E00]' : 'text-gray-600'}`} data-id="element-403">
    <div data-id="element-404">{icon}</div>
    <span className="text-xs mt-1" data-id="element-405">{label}</span>
  </Link>;
export default Navigation;